<template>
  <div>
    <div class="df jcsb aic">
      <span class="fs-20 lh-28 mic-semblod">{{ $t('我的积分') }}</span>

      <div>
        <el-button type="primary" @click="handleViewshow"
          class="minw-93 h-32 rounded-20 pt-0 pb-0 pl-16 pr-16">{{ $t('积分申请') }}</el-button>
        <el-button type="text" class="p-0" @click="openPointsRuleDialog">
          <span class="iconfont icon-a-svg11 c-59 mr-4"></span>
          <span class="fs-14 c-59">{{ $t('积分申请说明') }}</span>
        </el-button>
      </div>
    </div>

    <!-- 积分卡片 -->
    <div class="card-box mt-20 df">
      <div class="card-item" :title="$t('贡献积分') +':'+ (info.user_score ? info.user_score : '-')">
        <div class="d1 fs-14 lh-24 c-19 one-text">
          {{ $t("贡献积分") }}
        </div>
        <div class="d2 fs-28 lh-36 c-19 montserrat-text">{{ info.user_score ? info.user_score : '-' }}</div>
        <img src="@/assets/images/icon/icon-06.png" class="img" alt="" />
      </div>
      <div class="card-item ml-20" :title="$t('可兑换积分') +':'+ (info.user_now_score ? info.user_now_score : '-')">
        <div class="d1 fs-14 lh-24 c-19 one-text">
          {{ $t("可兑换积分") }}
        </div>
        <div class="d2 fs-28 lh-36 c-19 montserrat-text">{{ info.user_now_score ? info.user_now_score : '-' }}</div>
        <img src="@/assets/images/icon/icon-06.png" class="img" alt="" />
      </div>
      <div class="card-item ml-20" :title="$t('已消耗积分') +':'+ (info.tuap_total_consumed ? info.tuap_total_consumed : '-')">
        <div class="d1 fs-14 lh-24 c-19 one-text">
          {{ $t("已消耗积分") }}
        </div>
        <div class="d2 fs-28 lh-36 c-19 montserrat-text">{{ info.tuap_total_consumed ? info.tuap_total_consumed : '-' }}</div>
        <img src="@/assets/images/icon/icon-06.png" class="img" alt="" />
      </div>
      <div class="card-item ml-20" :title="$t('当前排名') +':'+ (info.rank ? info.rank : '-')">
        <div class="d1 fs-14 lh-24 c-19 one-text">
          {{ $t("当前排名") }}
        </div>
        <div class="d2 fs-28 lh-36 c-19 montserrat-text">{{ info.rank ? info.rank : '-' }}</div>
        <img src="@/assets/images/icon/icon-07.png" class="img" alt="" />
      </div>
    </div>

    <!-- 积分表格 -->
    <div class="point-table">
      <div class="point-tab">
        <span class="item" :class="tanIndex == 0 ? 'active' : ''" @click="handleTabIndex(0)">{{ $t("积分申请") }}</span>
        <span class="item" :class="tanIndex == 1 ? 'active' : ''" @click="handleTabIndex(1)">{{ $t("历史积分明细") }}</span>
      </div>


      <!-- 积分申请 -->
      <el-table :data="tableData" style="width: 100%" v-if="tanIndex == 0">
        <el-table-column prop="tgpa_scene_name" :label="$t('积分大类')" width="120">
        </el-table-column>
        <el-table-column :label="$t('积分小类')" width="140">
          <template slot-scope="scope">
            <div class="one-text pr-16" :title="scope.row.tgpp_name">
              {{ scope.row.tgpp_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('名称/编码')" width="130">
          <template slot-scope="scope">
            <div v-html="scope.row.tgpa_activity_name_code" class="one-text pr-16"
              :title="scope.row.tgpa_activity_name_code"></div>
          </template>
        </el-table-column>
        <el-table-column prop="tgpa_activity_desc" :label="$t('描述')" width="160">
          <template slot-scope="scope">

            <div class="one-text pr-16" :title="scope.row.tgpa_activity_desc">
              {{ scope.row.tgpa_activity_desc }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('积分值')">
          <template slot-scope="scope">
            {{ scope.row.tgpp_num }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('状态')" width="130" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" type="warning" v-if="scope.row.tgpa_status == 10">{{ $t('待审核') }}</el-tag>
            <el-tag size="mini" type="success" v-if="scope.row.tgpa_status == 20">{{ $t('审核中') }}</el-tag>
            <el-tag size="mini" v-if="scope.row.tgpa_status == 30">{{ $t('审核通过') }}</el-tag>
            <el-tag size="mini" v-if="scope.row.tgpa_status == 40">{{ $t('已驳回') }}</el-tag>
            <el-tag size="mini" type="info" v-if="scope.row.tgpa_status == 50">{{ $t('已撤回') }}</el-tag>
            <el-tag size="mini" v-if="scope.row.tgpa_status == 60">{{ $t('已驳回') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="showRejectColumn" :label="$t('驳回原因')" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.tgpa_status == 40" :title="scope.row.tgpa_reject_reason">
              {{ scope.row.tgpa_reject_reason || '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('举证图片')" width="120">
          <template slot-scope="scope">
            <template v-if="getEvidenceUrls(scope.row).length">
              <div class="evidence-thumbs pr-16">
                <el-image v-for="(url, idx) in getEvidenceUrls(scope.row).slice(0, 2)" :key="idx" :src="url" fit="cover"
                  :preview-src-list="getEvidenceUrls(scope.row)" class="evidence-thumb" @error="$erroravatarHandler" />
              </div>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('提交时间')" width="128">
          <template slot-scope="scope">
            <div class="fs-14">{{ formatTime(scope.row.tgpa_submit_time * 1000, 'YYYY-MM-DD HH:mm') }}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('操作')" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.tgpa_status == 50"
              type="text" size="mini" @click="handleViewDetail(scope.row)" class="operation-btn1"><i
                class="iconfont icon-tianxie"></i></el-button>
            <el-button v-if="scope.row.tgpa_status == 40"
              type="text" size="mini" @click="handleResubmit(scope.row)" class="operation-btn1">
              <i class="iconfont icon-tijiaofukuan"></i>
            </el-button>
            <el-button v-if="scope.row.tgpa_status == 10" type="text" size="mini" @click="handleWithdraw(scope.row)"
              class="operation-btn1"><i class="iconfont icon-withdraw"></i></el-button>
          </template>

        </el-table-column>
      </el-table>
      <!-- 分页：积分申请 -->
      <div class="pageing-box df aic jcc mt-24" v-if="tanIndex == 0 && tableData.length > 0">
        <el-button type="text" class="add-btn" @click="handlePointsPages(1)">{{ $t('回首页') }}</el-button>
        <el-pagination :current-page="pointsPagination.page" :page-size="pointsPagination.per_page"
          :total="pointsPagination.total" layout=" prev, pager, next,slot" @current-change="handlePointsCurrent">
          <span class="jump-text">{{ $t('跳转') }}</span>
          <el-input-number :controls="false" v-model="pointsJumpIndex" :min="1" :max="pointsTotalPages"
            @change="handlePointsJump" size="small" class="jump-ipt" style="width: 48px; margin-left: 8px;" />

        </el-pagination>
        <el-button type="text" class="add-btn ml-11" @click="handlePointsPages(pointsTotalPages)">{{ $t('去尾页')
        }}</el-button>
      </div>
      <template v-if="tanIndex == 1">
        <!-- 历史积分明细 -->
        <el-table :data="dataList" style="width: 100%">
          <el-table-column prop="tupd_remarks" :label="$t('内容')">
          </el-table-column>
          <el-table-column prop="create_time" :label="$t('时间')" align="center" width="160">
          </el-table-column>
          <el-table-column :label="$t('贡献值')" align="right" width="120">
            <template #default="{ row }">
              <span>{{ row.tupd_type === 10 || row.tupd_type === 20 ? '+' : '-' }} {{ row.tupd_item_score }}</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pageing-box df aic jcc mt-24" v-if="dataList.length > 0">
          <el-button type="text" class="add-btn" @click="handlePages(1)">{{ $t('回首页') }}</el-button>

          <el-pagination :current-page="pagination.page" :page-size="pagination.per_page" :total="pagination.total"
            layout=" prev, pager, next,slot" @current-change="handleCurrent">
            <span class="jump-text">{{ $t('跳转') }}</span>
            <el-input-number :controls="false" v-model="jumpIndex" :min="1" :max="totalPages" @change="handleJump"
              size="small" class="jump-ipt" style="width: 48px; margin-left: 8px;" />
          </el-pagination>

          <el-button type="text" class="add-btn ml-11" @click="handlePages(totalPages)">{{ $t('去尾页') }}</el-button>
        </div>

      </template>


    </div>

    <!-- 积分申请说明弹框 -->
    <el-dialog :title="$t('积分申请说明')" :visible.sync="showPointsRuleDialog" width="726px" custom-class="rounded-12"
      :close-on-click-modal="false">
      <div class="points-rule-content">
        <div v-if="pointsInstructions.content" v-html="pointsInstructions.content"></div>
        <template v-else>
          <div class="no-data">
            <img src="@/assets/images/empty_data.png" alt="">
            <p>{{ $t('暂无积分申请说明') }}</p>
          </div>
        </template>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showPointsRuleDialog = false" class="btn-confirm">{{ $t('我知道了') }}</el-button>
      </div>
    </el-dialog>

    <!-- 积分申请 -->
    <el-dialog :title="$t('积分申请')" width="726px" custom-class="rounded-12 address-dialog"
      :visible.sync="dialogFormVisible" @close="handleCancel">
      <el-form :model="addressForm" label-position="top" :rules="rules" ref="addressForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('积分场景')" prop="tgpa_scene">
              <el-select v-model="addressForm.tgpa_scene" :placeholder="$t('积分场景')" @change="handleSceneChange(true)">
                <el-option v-for="item in scenesList" :key="item.value" :label="item.label"
                  :value="String(item.value)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" prop="postal">
            <el-form-item :label="$t('积分项目')" prop="tgpp_id">
              <el-select v-model="addressForm.tgpp_id" :placeholder="$t('积分项目')">
                <el-option v-for="item in programsList" :key="item.tgpp_id" :label="item.tgpp_name"
                  :value="item.tgpp_id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('活动名称/编码')" prop="tgpa_activity_name_code">
          <!-- 证书(30)/期刊(40)：纯文本输入 -->
          <el-input v-if="sceneIsText" v-model="addressForm.tgpa_activity_name_code"
            :placeholder="$t('请输入活动名称/编码')"></el-input>
          <!-- 线下(10)/线上(20)：下拉选择 -->
          <el-select v-else v-model="addressForm.tgpa_activity_name_code" filterable allow-create
            :placeholder="$t('活动名称/编码')" @change="handleActivityChange">
            <el-option v-for="item in activityInfoList" :key="item.ta_id" :label="decodeHtml(item.ta_title)"
              :value="JSON.stringify(item)" style="max-width: 650px;"></el-option>
          </el-select>
        </el-form-item>

        <el-row :gutter="20" v-if="!(addressForm.tgpa_scene == '30' || addressForm.tgpa_scene == '40')">
          <el-col :span="12">
            <el-form-item :label="$t('活动地点')" prop="tgpa_activity_address">
              <template v-if="addressForm.ta_id === 0">
                <el-cascader v-model="addressForm.tgpa_activity_address" :options="areaOptions" :props="areaProps"
                  :show-all-levels="true" clearable :placeholder="$t('请选择活动地点')" />
              </template>
              <template v-else>
                <el-input v-model="addressForm.tgpa_activity_address" :placeholder="$t('请输入活动地点')"></el-input>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="12" prop="postal">
            <el-form-item :label="$t('活动时间')" prop="tgpa_activity_start_time">
              <el-date-picker style="width: 100%;" v-model="addressForm.tgpa_activity_start_time" :clearable="false"
                type="datetimerange" format="yyyy-MM-dd HH:mm" :start-placeholder="$t('开始日期')"
                :end-placeholder="$t('结束日期')" :default-time="['12:00:00']">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item :label="$t('描述')" prop="tgpa_activity_desc">
          <el-input type="textarea" :placeholder="$t('请输入')" :autosize="{ minRows: 2, maxRows: 6 }"
            v-model="addressForm.tgpa_activity_desc">
          </el-input>
        </el-form-item>

        <el-form-item :label="$t('上传举证')" prop="tgpa_evidence_image">
          <div class="upload-demo mt-4">
            <!--  :fileList="addressForm.tgpa_evidence_image" -->
            <Uploadimg v-model="addressForm.tgpa_evidence_image" ref="uploadRef" :fileLimit="5" upType="picture" :isUseOss="true" />
          </div>
          <div class="fs-12 lh-20 c-59 mt-8">{{ $t('最多上传5张') }}</div>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" class="btn1" @click="handleCancel">{{ $t('取消') }}</el-button>
        <el-button type="primary" class="btn2 c-f" @click="submitForm">{{ $t('保存8') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPointsList,
  submitPoints,
  getScenesList,
  getProgramsList,
  getActivityInfo,
  getPointsInfo,
  editPoints,
  withdrawPoints,
  getPointsInstructions,
  getAreaKeyVal,
  resubmitPoints,
} from "@api/points";

import { getscore } from "@api/usercenter";

import Uploadimg from "@comp/Uploadimg/index.vue";
export default {
  name: "Points",
  components: {
    Uploadimg,
  },
  computed: {
    // 仅当“积分申请”页签下存在已驳回的记录时，显示“驳回原因”整列
    showRejectColumn() {
      if (this.tanIndex !== 0) return false;
      const list = Array.isArray(this.tableData) ? this.tableData : [];
      return list.some((item) => {
        const status = typeof item.tgpa_status === 'string' ? Number(item.tgpa_status) : item.tgpa_status;
        return status === 40;
      });
    },
    // 证书(30)/期刊(40) 使用纯文本输入
    sceneIsText() {
      const s = String(this.addressForm.tgpa_scene || '');
      return s === '30' || s === '40';
    },
  },
  data() {
    return {

      // 场景列表
      scenesList: [],
      // 项目列表
      programsList: [],
      // 活动区域列表
      keywords: "",
      activityInfoList: [],
      showPointsRuleDialog: false,
      pointsInstructions: {
        content: "",
      },
      dialogFormVisible: false,
      isResubmit: false,
      source_tgpa_id: 0,

      addressForm: {
        tgpa_id: "", //申请id
        tgpa_scene: "",
        tgpp_id: "",
        tgpa_evidence_image: "[]",
        tgpa_activity_desc: "",
        tgpa_activity_name_code: "",
        tgpa_activity_start_time: "",
        tgpa_activity_end_time: "",
        tgpa_activity_address: "",
        ta_id: 0,
      },
      areaOptions: [],
      areaProps: { value: 'value', label: 'label', children: 'children', emitPath: false, checkStrictly: true },
      // 编辑模式下，记录初始已存在的图片，用于过滤只提交新增图片
      initialEvidenceImage: [],
      rules: {
        tgpa_scene: [{ required: true, message: this.$t("请选择积分场景"), trigger: "blur" }],
        tgpp_id: [{ required: true, message: this.$t("请选择积分项目"), trigger: "blur" }],
        tgpa_activity_name_code: [
          { required: true, message: this.$t("请输入活动名称/编码"), trigger: "blur" },
        ],
        tgpa_activity_start_time: [{ required: true, message: this.$t("请选择活动时间"), trigger: "blur" }],
        tgpa_activity_address: [{ required: true, message: this.$t("请输入活动地点"), trigger: "blur" }],
        tgpa_evidence_image: [
          { required: true, message: this.$t("请上传举证"), trigger: "blur" },
        ],
      },

      // 积分申请表格数据
      tableData: [],
      // 积分申请分页
      pointsPagination: {
        total: 0,
        page: 1,
        per_page: 10
      },
      pointsJumpIndex: 1,
      pointsTotalPages: 1,

      tanIndex: 0,

      // 分页
      pagination: {
        total: 0,
        page: 1,
        per_page: 16
      },

      info: {},
      dataList: [],
      jumpIndex: 1,
      totalPages: 1,

    };
  },
  created() {
    this.getData();
  },
  mounted() {



  },
  methods: {

    // 积分申请
    handleViewshow() {
      this.addressForm.tgpa_evidence_image='[]'
      this.dialogFormVisible = true;
    },

    // 分页

    handlePages(page) {
      this.pagination.page = page;
      this.handleCurrent(page);
    },
    handleCurrent(page) {
      this.pagination.page = page;
      this.handlehistory();
    },

    handleJump() {
      this.pagination.page = this.jumpIndex;
      this.handlehistory();
    },


    handleTabIndex(index) {
      this.tanIndex = index;
    },

    // 撤回
    handleWithdraw(row) {
      this.$confirm(this.$t('确定撤回该申请吗？'), this.$t('提示'), {
        type: 'warning'
      }).then(() => {
        withdrawPoints({ tgpa_id: row.tgpa_id }).then((res) => {
          if (res.status === 200) {
            this.$message({ message: this.$t('撤回成功'), type: 'success' });
            this.getData();
          } else {
            this.$message.error(res.msg || this.$t('操作失败'));
          }
        });
      }).catch(() => { });
    },
    // 编辑
    handleViewDetail(row) {
      this.addressForm = {
        tgpa_id: '',
        tgpa_scene: '',
        tgpp_id: '',
        tgpa_evidence_image: '[]',
        tgpa_activity_desc: '',
        tgpa_activity_name_code: '',
        tgpa_activity_start_time: '',
        tgpa_activity_end_time: '',
        tgpa_activity_address: '',
      };
      getPointsInfo({ tgpa_id: row.tgpa_id }).then((res) => {
        if (res.status === 200) {
          const info = res.data.info || {};
          this.addressForm.tgpa_id = info.tgpa_id;
          this.addressForm.tgpa_scene = String(info.tgpa_scene || '');
          this.addressForm.tgpp_id = info.tgpp_id || '';
          // 解析后端返回的图片列表，既用于展示也用于后续过滤新增图片
          const oldImgs = this.deepParseJson(info.tgpa_evidence_image || '[]');

          this.initialEvidenceImage = Array.isArray(oldImgs) ? [...oldImgs] : [];

          this.addressForm.tgpa_evidence_image = JSON.stringify(Array.isArray(oldImgs) ? [...oldImgs] : []);

          this.addressForm.tgpa_activity_desc = info.tgpa_activity_desc || '';
          this.addressForm.tgpa_activity_name_code = info.tgpa_activity_name_code || '';
          if (info.tgpa_activity_start_time && info.tgpa_activity_end_time) {
            // 兼容后端返回秒/毫秒时间戳
            const st = this.normalizeTs(info.tgpa_activity_start_time);
            const et = this.normalizeTs(info.tgpa_activity_end_time);
            this.addressForm.tgpa_activity_start_time = [st, et];
          }
          console.log(this.addressForm, ".............");
          this.addressForm.tgpa_activity_address = info.tgpa_activity_address || '';
          this.addressForm.ta_id = Number(info.ta_id || 0);
          if (this.addressForm.ta_id === 0) {
            this.addressForm.tgpa_activity_address = Number(info.tgpa_city || 0);
            this.fetchAreaOptions();
          }
          this.dialogFormVisible = true;
          this.isResubmit = false;
          this.source_tgpa_id = 0;
          // 加载项目列表以匹配选择
          if (this.addressForm.tgpa_scene) {
            this.handleSceneChange(false);
          }
        }
      });
    },

    // 再次提交（基于已驳回记录）
    handleResubmit(row) {
      this.addressForm = {
        tgpa_id: '',
        tgpa_scene: '',
        tgpp_id: '',
        tgpa_evidence_image: '[]',
        tgpa_activity_desc: '',
        tgpa_activity_name_code: '',
        tgpa_activity_start_time: '',
        tgpa_activity_end_time: '',
        tgpa_activity_address: '',
      };
      getPointsInfo({ tgpa_id: row.tgpa_id }).then((res) => {
        if (res.status === 200) {
          const info = res.data.info || {};
          this.source_tgpa_id = Number(info.tgpa_id || 0);
          this.addressForm.tgpa_scene = String(info.tgpa_scene || '');
          this.addressForm.tgpp_id = info.tgpp_id || '';
          const oldImgs = this.deepParseJson(info.tgpa_evidence_image || '[]');
          this.initialEvidenceImage = Array.isArray(oldImgs) ? [...oldImgs] : [];
          this.addressForm.tgpa_evidence_image = JSON.stringify(Array.isArray(oldImgs) ? [...oldImgs] : []);
          this.addressForm.tgpa_activity_desc = info.tgpa_activity_desc || '';
          this.addressForm.tgpa_activity_name_code = info.tgpa_activity_name_code || '';
          if (info.tgpa_activity_start_time && info.tgpa_activity_end_time) {
            const st = this.normalizeTs(info.tgpa_activity_start_time);
            const et = this.normalizeTs(info.tgpa_activity_end_time);
            this.addressForm.tgpa_activity_start_time = [st, et];
          }
          this.addressForm.tgpa_activity_address = info.tgpa_activity_address || '';
          this.addressForm.ta_id = Number(info.ta_id || 0);
          if (this.addressForm.ta_id === 0) {
            this.addressForm.tgpa_activity_address = Number(info.tgpa_city || 0);
            this.fetchAreaOptions();
          }
          this.isResubmit = true;
          this.dialogFormVisible = true;
          if (this.addressForm.tgpa_scene) {
            this.handleSceneChange(false);
          }
        }
      });
    },

    // 提交申请
    submitForm() {
      console.log(this.addressForm, ".............");
      this.$refs.addressForm.validate((valid) => {
        if (valid) {
          let formData = {
            ...this.addressForm,
          }
          // 处理活动时间
          if (Array.isArray(this.addressForm.tgpa_activity_start_time) && this.addressForm.tgpa_activity_start_time.length === 2) {
            const st = this.addressForm.tgpa_activity_start_time[0];
            const et = this.addressForm.tgpa_activity_start_time[1];
            const toSec = (v) => {
              if (!v) return 0;
              if (typeof v === 'number') return Math.floor(v < 1e12 ? v : v / 1000);
              if (v instanceof Date) return Math.floor(v.getTime() / 1000);
              const n = Number(v);
              return Number.isFinite(n) ? Math.floor(n < 1e12 ? n : n / 1000) : 0;
            };
            formData.tgpa_activity_start_time = toSec(st);
            formData.tgpa_activity_end_time = toSec(et);
          }

          // 统一将活动名称/编码按后端要求传递为活动名称（ta_title 或用户输入的文本）
          const parsed = this.safeParseJson(this.addressForm.tgpa_activity_name_code);
          const rawTitle = parsed && parsed.ta_title ? parsed.ta_title : (typeof this.addressForm.tgpa_activity_name_code === 'string' ? this.addressForm.tgpa_activity_name_code : '');
          formData.tgpa_activity_name_code = this.decodeHtml(rawTitle);
          formData.ta_id = parsed && parsed.ta_id ? Number(parsed.ta_id) : 0;
          formData.tgpa_city = formData.ta_id ? Number((parsed && parsed.ta_city) || 0) : Number(this.addressForm.tgpa_activity_address || 0);

          // 仅提交新增图片：过滤掉编辑打开时已经存在的图片
          const currentArr = Array.isArray(this.addressForm.tgpa_evidence_image)
            ? this.addressForm.tgpa_evidence_image : this.deepParseJson(this.addressForm.tgpa_evidence_image || '[]') || [];
          const initialKeys = this.getImageKeys(this.initialEvidenceImage);
          const newOnly = (currentArr || []).filter((it) => {
            const key = this.getImageKey(it);
            return key && !initialKeys.has(key);
          });

          // 去掉过滤，直接提交所有图片
          // formData.tgpa_evidence_image = JSON.stringify(newOnly);

          let apiCall;
          if (this.isResubmit) {
            apiCall = resubmitPoints;
            formData.source_tgpa_id = this.source_tgpa_id;
            formData.tgpa_id = this.source_tgpa_id;
          } else {
            apiCall = this.addressForm.tgpa_id ? editPoints : submitPoints;
          }
          apiCall(formData).then((res) => {
            if (res.status === 200) {
              const msg = this.isResubmit
                ? this.$t('提交成功')
                : (this.addressForm.tgpa_id ? this.$t('编辑成功') : this.$t('积分申请提交成功'));
              this.$message({ message: msg, type: 'success' });
              this.dialogFormVisible = false;
              this.isResubmit = false;
              this.source_tgpa_id = 0;
              this.getData();
            } else if (res.status === 4022) {
              this.$message.error(res.msg || this.$t('操作失败'));
            }
          });
        } else {
          return false;
        }
      });
    },

    // 活动名称/编码改变时，获取活动区域列表
    handleActivityChange(e) {
      const activity = this.safeParseJson(e);
      // 选择了下拉中的活动（JSON字符串）
      if (activity && typeof activity === 'object') {
        const st = this.normalizeTs(activity.ta_start_time);
        const et = this.normalizeTs(activity.ta_end_time);
        this.addressForm.tgpa_activity_start_time = [st, et];
        this.addressForm.tgpa_activity_address = activity.ta_address;
        this.addressForm.ta_id = Number(activity.ta_id || 0);
        if (this.addressForm.ta_id === 0) {
          this.fetchAreaOptions();
        }
        // 不修改 v-model 值，提交时再提取 ta_title
      } else {
        // 用户自定义文本或不可解析，清空自动填充字段
        this.addressForm.tgpa_activity_start_time = [];
        this.addressForm.tgpa_activity_address = '';
        this.addressForm.ta_id = 0;
        this.fetchAreaOptions();
      }
    },
    // 映射积分场景到活动种类
    getTaKindByScene(scene) {
      const s = Number(scene || 0);
      // 场景：线下(10)/线上(20) → ta_kind：线上(10)/线下(20)
      if (s === 10) return 20;
      if (s === 20) return 10;
      return 0;
    },
    fetchAreaOptions() {
      getAreaKeyVal({}).then((res) => {
        if (res && res.status === 200) {
          const raw = Array.isArray(res.data) ? res.data : (res.data && res.data.list) || [];
          this.areaOptions = this.pruneEmptyChildren(raw);
        }
      });
    },
    pruneEmptyChildren(arr) {
      const walk = (items) => (items || []).map((it) => {
        const node = { ...it };
        const children = Array.isArray(node.children) ? node.children : [];
        if (children.length > 0) {
          node.children = walk(children);
        } else {
          delete node.children;
        }
        return node;
      });
      return walk(arr);
    },

    // 场景改变时，获取项目列表
    handleSceneChange(resetPrograms = true) {
      if (resetPrograms) {
        this.addressForm.tgpp_id = '';
        this.programsList = [];
      }
      getProgramsList({
        tgpp_scene: Number(this.addressForm.tgpa_scene || 0),
      }).then((res) => {
        if (res.status == 200) {
          this.programsList = res.data.programs;
        }
      });
      const taKind = this.getTaKindByScene(this.addressForm.tgpa_scene);
      getActivityInfo({ keywords: this.keywords, ta_kind: taKind }).then((res) => {
        if (res.status == 200) {
          this.activityInfoList = res.data;
        }
      });
    },
    // 取消按钮：关闭弹窗并重置表单
    handleCancel() {
      this.dialogFormVisible = false;
      this.isResubmit = false;
      this.source_tgpa_id = 0;
      if (this.$refs.addressForm && this.$refs.addressForm.resetFields) {
        this.$refs.addressForm.resetFields();
      }
      // 额外确保数据清空
      this.addressForm = {
        tgpa_id: '',
        tgpa_scene: '',
        tgpp_id: '',
        tgpa_evidence_image: '[]',
        tgpa_activity_desc: '',
        tgpa_activity_name_code: '',
        tgpa_activity_start_time: '',
        tgpa_activity_end_time: '',
        tgpa_activity_address: '',
      };
      this.addressForm.tgpa_evidence_image ='[]';
      this.initialEvidenceImage = [];
      this.programsList = [];
    },
    getData() {



      // 获取积分列表

      this.fetchPointsList();

      // 获取场景列表
      getScenesList().then((res) => {
        if (res.status == 200) {
          this.scenesList = res.data;
        }
      });

      // 获取活动区域列表（按场景映射 ta_kind 过滤）
      const taKindInit = this.getTaKindByScene(this.addressForm.tgpa_scene);
      getActivityInfo({ keywords: this.keywords, ta_kind: taKindInit }).then((res) => {

        if (res.status == 200) {
          this.activityInfoList = res.data;
        }
      });

      this.handlehistory();

    },

    // 拉取积分申请列表（分页）
    fetchPointsList() {

      const loading = this.$loading({
        lock: true,
        text: this.$t('拼命加载中'),
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });

      getPointsList({
        page: this.pointsPagination.page,
        per_page: this.pointsPagination.per_page,
      }).then((res) => {
        loading.close();
        if (res.status == 200) {
          const d = res.data || {};
          this.tableData = d.list || [];
          this.pointsPagination.total = Number(d.total || 0);
          this.pointsPagination.per_page = Number(d.per_page || this.pointsPagination.per_page);
          this.pointsPagination.page = Number(d.page || this.pointsPagination.page);
          this.pointsTotalPages = Math.max(1, Math.ceil(this.pointsPagination.total / this.pointsPagination.per_page));
          this.pointsJumpIndex = this.pointsPagination.page;
        }
      });

    },

    // 积分申请分页交互
    handlePointsPages(page) {
      this.pointsPagination.page = page;
      this.handlePointsCurrent(page);
    },
    handlePointsCurrent(page) {
      this.pointsPagination.page = page;
      this.fetchPointsList();
    },
    handlePointsJump() {
      this.pointsPagination.page = this.pointsJumpIndex;
      this.fetchPointsList();
    },
    // 获取历史积分明细
    handlehistory() {
      // 获取历史积分明细
      getscore({ page: this.pagination.page }).then((res) => {
        if (res.status == 200) {
          this.info = res.data.info;
          this.dataList = res.data.data;
          this.pagination.total = res.data.total;
          this.pagination.per_page = res.data.per_page;
          this.totalPages = Math.ceil(this.pagination.total / this.pagination.per_page);
        }
      });

    },

    openPointsRuleDialog() {
      // 打开弹框前获取说明
      getPointsInstructions().then((res) => {
        if (res && res.status === 200) {
          // 兼容两种返回结构：
          // 1) { status:200, data: { content: '...' } }
          // 2) { status:200, data: { status:200, data: { content:'...' } } }
          const d1 = res.data || {};
          const d2 = d1 && d1.data ? d1.data : {};
          this.pointsInstructions.content = (d1.content || d2.content || "");
        } else {
          this.$message.error(res.msg || this.$t('加载积分申请说明失败'));
        }
        this.showPointsRuleDialog = true;
      }).catch(() => {
        this.showPointsRuleDialog = true;
      });
    },

    removeImage(index) {
      this.addressForm.proof.splice(index, 1);
    },
    // 安全解析JSON字符串
    safeParseJson(val) {
      if (typeof val !== 'string') return null;
      try { return JSON.parse(val); } catch (e) { return null; }
    },
    // 深度解析可能被转义的JSON字符串（例如 "[{}]" 这种二次编码）
    deepParseJson(val) {
      let cur = val;
      for (let i = 0; i < 3; i++) {
        if (typeof cur === 'string') {
          const t = cur.trim();
          if ((t.startsWith('{') && t.endsWith('}')) || (t.startsWith('[') && t.endsWith(']'))) {
            try { cur = JSON.parse(cur); continue; } catch (e) { break; }
          }
        }
        break;
      }
      return cur;
    },
    // 生成图片唯一键（优先 att_id，其次 att_url）
    getImageKey(item) {
      if (!item || typeof item !== 'object') return '';
      const id = Number(item.att_id || 0);
      const url = String(item.att_url || '').trim();
      return id > 0 ? `id:${id}` : (url ? `url:${url}` : '');
    },
    // 将初始图片列表转为 Set 以便快速过滤
    getImageKeys(list) {
      const s = new Set();
      (Array.isArray(list) ? list : []).forEach((it) => {
        const k = this.getImageKey(it);
        if (k) s.add(k);
      });
      return s;
    },
    // 兼容秒或毫秒时间戳
    normalizeTs(val) {
      if (!val) return '';
      const num = Number(val);
      if (!Number.isFinite(num)) return '';
      // 秒级通常小于 1e12；毫秒级通常大于 1e12
      return num < 1e12 ? num * 1000 : num;
    },
    // 解码 HTML 实体（例如 &amp; -> &）
    decodeHtml(str) {
      if (typeof str !== 'string') return str;
      const txt = document.createElement('textarea');
      txt.innerHTML = str;
      return txt.value;
    },
    // 解析举证图片URL列表（用于预览与展示）
    getEvidenceUrls(row) {
      // 优先使用模型追加字段 tgpa_evidence_image_arr（后端已拼完整URL）
      const arr1 = (row && Array.isArray(row.tgpa_evidence_image_arr)) ? row.tgpa_evidence_image_arr : [];
      if (arr1.length) return arr1.filter(Boolean);
      // 兼容旧字段 tgpa_evidence_image
      const val = row && row.tgpa_evidence_image;
      if (!val) return [];
      try {
        const arrRaw = typeof val === 'string' ? this.deepParseJson(val) : val;
        const arr = Array.isArray(arrRaw) ? arrRaw : [];
        if (Array.isArray(arr)) {
          return arr.map(i => i.att_url).filter(Boolean);
        }
        return [];
      } catch (e) {
        return [];
      }
    }
  },

};
</script>

<style lang="scss" scoped>
.points-rule-content {
  overflow-x: hidden;

  ::v-deep() {
    img {
      max-width: 100%;
      height: auto;
    }
  }
}

.el-button--text.operation-btn1 {
  color: #000000;

  &:hover {
    color: #b7251e;
  }
}

::v-deep() {
  .el-form-item__error {
    padding-top: 0px !important;
    margin-top: -2px;
  }

  .el-scrollbar {
    max-width: 661px;
  }

  .el-date-editor .el-range__icon,
  .el-date-editor .el-range-separator {
    line-height: 24px !important;
  }

  .el-popper,
  .el-select-dropdown {
    max-width: 661px;
  }

  .el-scrollbar__wrap {
    max-width: 661px;
  }

  .point-tab {
    padding-top: 20px;
    margin-bottom: 8px;

    .item {
      font-size: 16px;
      line-height: 24px;
      color: rgb(89, 89, 89);
      margin-right: 36px;
      cursor: pointer;

      &.active,
      &:hover {
        color: #a83328;
      }
    }
  }

  .point-table {

    .el-table th.el-table__cell.is-leaf,
    .el-table td.el-table__cell {
      border: none;
    }

    .el-table th.el-table__cell>.cell {
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
      color: rgb(25, 25, 25);
      padding-left: 0;
    }

    .el-table td.el-table__cell .cell {
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
      color: rgb(89, 89, 89);
      padding: 0;
    }

    .el-table .el-table__cell {
      padding: 8px 0;
    }

    .el-table th.el-table__cell.is-leaf {
      padding: 7px 0;
    }
  }

  /* 级联选择器（地区树）无限级支持：取消宽度上限，启用横向滚动 */
  .el-cascader__dropdown {
    max-width: none !important;
  }

  .el-cascader__dropdown .el-scrollbar {
    max-width: none !important;
  }

  .el-cascader__dropdown .el-scrollbar__wrap {
    max-width: none !important;
    overflow-x: auto !important;
  }

  .el-cascader-panel {
    min-width: auto !important;
    white-space: nowrap;
  }

  .el-cascader-menu {
    min-width: 180px;
  }
}

.card-box {
  padding-bottom: 24px;
  border-bottom: 1px dotted #b8bfd9;

  .card-item {
    width: 273px;
    height: 93px;
    border: 0.5px solid rgba(25, 25, 25, 0.3);
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    padding: 14px 3.2%;

    .img {
      width: 51px;
      height: 51px;
      position: absolute;
      right: 19px;
      top: -6px;
    }

    .d1{
      position: relative;
      z-index: 100;
    }

    .d2 {
      letter-spacing: 0.5px;
      // 斜体
      font-style: italic;
      margin-top: 8px;
    }
  }
}

::v-deep() {
  .el-textarea__inner {
    min-height: 72px !important;
  }

  .el-upload.el-upload--picture {
    width: 116px;
    height: 116px;
    min-height: 116px;
    border: 1px dashed rgba(201, 201, 201, 1);
    border-radius: 6px;
    position: relative;
    margin-right: 16px;

    .el-upload__text {
      display: none;
    }

    .iconfont {
      color: #fff !important;

      &::after {
        content: "\e623";
        font-family: "iconfont";
        color: #595959;
        font-size: 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .el-upload-list--picture .el-upload-list__item {
    width: 116px;
    height: 116px;
    min-height: 116px;
    border: 1px dashed rgba(201, 201, 201, 1);
    border-radius: 6px;
    padding: 0;
    position: relative;
    margin-top: 0;
    margin-right: 16px;
  }

  .el-upload-list--picture .el-upload-list__item-thumbnail {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    margin: 0;
  }

  .el-upload-list__item.is-success .el-upload-list__item-status-label,
  .el-upload-list__item .el-icon-close,
  .el-upload-list__item .el-icon-close-tip {
    z-index: 100;
  }

}

::v-deep() {
  .el-select {
    width: 100%;
  }

  .address-dialog {
    border-radius: 12px;

    .el-dialog__header {
      padding: 28px 30px 18px;
    }

    .el-dialog__body {
      padding: 0 30px;
    }

    .el-form-item {
      margin-bottom: 8px !important;

      .el-checkbox__label {
        color: #191919;
      }

      .el-input__inner,
      .el-textarea__inner {
        &::placeholder {
          color: #aeaeae;
          font-size: 14px !important;
        }

        border-color: #c9c9c9;
      }

      .el-textarea__inner {
        min-height: 73px !important;
      }
    }

    .el-form--label-top .el-form-item__label {
      font-size: 14px;
      color: #595959;
      line-height: 24px !important;
      padding: 0 !important;
    }

    .el-input__inner {
      height: 30px;
      line-height: 30px;
    }

    .el-dialog__footer {
      padding-top: 32px;
    }

    .dialog-footer {
      button {
        height: 32px !important;
        line-height: 30px !important;
        padding: 0 16px;
        min-width: 92px;
        border-radius: 30px;
      }
    }
  }
}

.dialog-footer {
  button {
    min-width: 93px;
    height: 32px;
    padding: 0 16px;
    border-radius: 60px;
    font-size: 12px;
    color: rgba(0, 0, 0, 1);
    border-color: rgba(174, 174, 174, 1);

    &:hover {
      border-color: #b7251e;
      color: #b7251e;
    }
  }
}

/* 列表举证图片缩略图：仅显示2张，超出隐藏 */
.evidence-thumbs {
  display: flex;
  gap: 6px;
  align-items: center;
  max-width: 92px;
  /* 2*40px + 间距，确保第三张被隐藏 */
  overflow: hidden;
}

.evidence-thumb {
  width: 40px;
  height: 40px;
  border-radius: 4px;
}
</style>
